import loadable from "@loadable/component";
const IconCSS = loadable.lib(props => import(`../../font/${props.pageName}/style.css`),{
	cacheKey: props => props.page
});

export default IconCSS;
